import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import EditRakeMovementForm from './EditRakeMovementForm';

const EditRakeMovementDialog = ({ open, onOpenChange, rakeData, onUpdateRakeMovement }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      await onUpdateRakeMovement(data);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto p-6">
        <DialogHeader className="mb-4">
          <DialogTitle className="text-lg font-semibold text-foreground">
            Edit Rake Movement — {rakeData?.trip_number}
          </DialogTitle>
        </DialogHeader>
        <EditRakeMovementForm
          rakeData={rakeData}
          onUpdateRakeMovement={handleSubmit}
          onCancel={() => onOpenChange(false)}
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditRakeMovementDialog;
